import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {Button, IconButton} from '@material-ui/core';
import {Edit as EditIcon, DeleteForever as DeleteForeverIcon} from '@material-ui/icons';
import {CommonModal, DeletionConfirmBox} from 'components/common';
import {SecondaryNavigation} from 'components/Navigation';
import BookUpdate from './BookUpdate';
import {deleteBook, toggleBookStatus} from 'api/books';
import {fetchBook} from 'actions/books';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import * as permissions from 'utils/permissions';

class BookDetail extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  static propTypes = {
    book: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      updateModalShown: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchBook = this.fetchBook.bind(this);
    this.deleteBook = this.deleteBook.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
  }

  componentDidMount() {
    this.fetchBook();
  }

  fetchBook() {
    const {
      fetchBook,
      formatErrors,
      match: {
        params: {bookId},
      },
    } = this.props;
    fetchBook(bookId).catch((err) => formatErrors(err, '/books'));
  }

  showModal(type) {
    this.setState({
      [`${type}ModalShown`]: true,
    });
  }

  closeModal(type) {
    this.setState({
      [`${type}ModalShown`]: false,
    });
  }

  deleteBook() {
    const {
      addFlashMessage,
      formatErrors,
      match: {
        params: {bookId},
      },
    } = this.props;
    deleteBook(bookId)
      .then(() => {
        addFlashMessage('The book has been successfully deleted!', 'success');
        this.context.router.history.push('/books');
      })
      .catch((err) => formatErrors(err));
  }

  changeStatus() {
    const {book, addFlashMessage, formatErrors} = this.props;
    toggleBookStatus(book.id)
      .then(() => {
        this.fetchBook();
        addFlashMessage('Book status has been successfully updated!', 'success');
      })
      .catch((err) => formatErrors(err));
  }

  render() {
    const {updateModalShown} = this.state;
    const {me, book} = this.props;
    const closeUpdateModal = () => this.closeModal('update');
    return (
      <React.Fragment>
        <SecondaryNavigation hasBack />
        <div className="container content-box">
          <Panel>
            <CommonModal title="Edit Book" onClose={closeUpdateModal} show={updateModalShown}>
              <BookUpdate book={book} onSubmitSuccess={closeUpdateModal} />
            </CommonModal>
            <h3 className="section-header">
              <div className="section-title">Book Information</div>
              {(permissions.isKluwellAdmin(me.role) || (book.status !== 'public' && me.id === book.addedById)) && (
                <div>
                  <DeletionConfirmBox
                    itemName="book"
                    deleteAction={this.deleteBook}
                    DeleteButton={(props) => (
                      <IconButton variant="contained" color="primary" {...props}>
                        <DeleteForeverIcon />
                      </IconButton>
                    )}
                  />
                  <IconButton variant="contained" color="primary" onClick={() => this.showModal('update')}>
                    <EditIcon />
                  </IconButton>
                </div>
              )}
            </h3>
            {permissions.isKluwellAdmin(me.role) && (
              <Button variant="contained" color="primary" className="pull-right" onClick={this.changeStatus}>
                {book.status === 'public' ? 'Mark Unapproved' : 'Approve'}
              </Button>
            )}
            <div className="table-block">
              <div className="table-row">
                <div className="table-cell">Title</div>
                <div className="table-cell text-capitalize">{book.title}</div>
              </div>
              <div className="table-row">
                <div className="table-cell">Status</div>
                <div
                  className={classNames({
                    'table-cell': true,
                    'text-bold': true,
                    'text-capitalize': true,
                    'text-green': book.status === 'public',
                    'text-red': book.status === 'pending',
                  })}
                >
                  {book.status}
                </div>
              </div>
            </div>
          </Panel>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {account, books} = state;
  return {
    me: account.get('user').toJS(),
    book: books.get('currentBook').toJS(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  fetchBook: (...args) => dispatch(fetchBook(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookDetail);
